import { Button } from "antd";
import { ClockCircleFilled } from '@ant-design/icons';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useClient } from "../../context/ClientContext";
import { getContrastColor } from "../../utils/colorContrast";

export const PedidoPendiente = () => {
  const navigate = useNavigate();
  const { clientId, theme , clientPath} = useClient();
  const [params] = useSearchParams();
  const pedidoId = params.get("external_reference");
  const primaryColor = theme?.primaryColor || '#f59e0b';
  const primaryTextColor = getContrastColor(primaryColor);

  return (
    <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
      <div style={{ textAlign: "center", maxWidth: 480 }}>
        <ClockCircleFilled style={{ fontSize: 100, color: "#f59e0b" }} />
        <h1 style={{ fontWeight: 700, marginTop: 16, marginBottom: 8 }}>Pago pendiente</h1>
        <p style={{ fontSize: 16, color: "#666", marginBottom: pedidoId ? 12 : 28 }}>
          Tu pago está siendo procesado. Te avisaremos cuando se confirme.
        </p>
        {pedidoId && <p style={{ fontSize: 14, color: "#999", marginBottom: 28 }}>Pedido #{pedidoId}</p>}
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          {pedidoId && (
            <Button onClick={() => navigate(clientPath(`/mis-pedidos/${pedidoId}`))} style={{ fontWeight: 600, borderRadius: 8 }}>
              Ver pedido
            </Button>
          )}
          <Button
            type="primary"
            onClick={() => navigate(clientPath('/mis-pedidos'))}
            style={{ backgroundColor: primaryColor, borderColor: primaryColor, color: primaryTextColor, fontWeight: 700, borderRadius: 8 }}
          >
            Mis pedidos
          </Button>
        </div>
      </div>
    </div>
  );
};
